//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Toast } from 'mint-ui';
import { Picker } from 'mint-ui';
import { formatTime, guid, isNullOrEmptyStr } from "@/utils/common"
import { BASIC, PROJ_URL } from "@/config/constant"
import promise from '@/axios/promise';
import Message from 'muse-ui-message';
import { debug } from 'util';

export default {
  name: 'dayReportAdd',
  data() {
    return {
      type: this.$route.query.type,
      userInfo: {},
      totalHour: '',
      totalPirce: 0,
      solo: true,
      form: {
        id: this.$route.query.id,
        signId: '',
        reportTime: this.$route.query.reportDate,
        reportAddr: '',
        signTime: '',
        signAddr: '',
        signCity: '',
        reportLongitude: '',
        reportDimension: '',
        reportCityCode: '',
        reportCity: '',
        reportPlace: '',
        status: '',
        creater: '',
        createTime: '',
        deptId: '',
        deptCode: '',
        totalHour: '',
        totalPrice: 0,
        deptName: '',
        grade: '',
        userType: '',
        origTotalSubsidy: 0,
        workTotalSubsidy: 0,
        workTotalHour: 0,
        origTotalHour: 0,
        //日报补贴金额
        workSubsidyAmt: 0,
        inSignScope: '否',
        unitPriceType: undefined,
      },
      reportDetailList: [],
      projList: [],
      workHourList: [],
      scopeList: [],
      map: null,
      selectName: '', // 项目选择的名字
      projIndex: 0, // 项目的下标值
      docked: false,
      open: false,
      position: 'right',
      isChangeColor: false,
      searchProject1: '',
      datalist: [],
      // 结算单价类型
      unitPriceTypes: [{ code: 0, name: "现场" }, { code: 1, name: "远程" }],
    }
  },
  watch: {
    'open': {
      handler(newVal, oldVal) {
        if (this.open == true) {
          $('.myContainer').css('overflow', 'hidden')
        }
        if (this.open == false) {
          $('.myContainer').css('overflow', 'auto')
        }
      },
      deep: true
    }
  },
  methods: {
    // 点击输入框，弹出右侧边栏
    showProj(ev) {
      this.projIndex = ev
      this.open = true;
      // 再次点击时使搜索框内的input值清空掉，使其重新输入
      this.searchProject1 = ''
      this.datalist = this.projList.filter(function (item, index, arr) {
        return item.projName.indexOf("") != -1;
      })
    },
    // 点击确定按钮，进行回传值
    projectConfirm() {
      var val = this.selectName;
      this.reportDetailList[this.projIndex].projName = this.selectName;
      this.open = false
      var proj = null;
      for (var i = 0; i < this.datalist.length; i++) {
        var item = this.datalist[i];
        if (item.projName == val) {
          proj = item;
        }
      }
      if (proj != null && proj != undefined) {
        this.reportDetailList[this.projIndex].projCode = proj.projCode;
        this.reportDetailList[this.projIndex].projName = proj.projName;
        this.reportDetailList[this.projIndex].projId = proj.id;
      }

    },
    // 点击项目进行重新获取值
    projShow(index) {
      // 清楚所有的颜色，给点击的加上颜色
      var projectList = document.getElementsByClassName('project-list');
      for (var i = 0; i < projectList.length; i++) {
        projectList[i].style.background = '#fff';
      }
      projectList[index].style.background = '#ececec';
      this.selectName = this.datalist[index].projName;
    },
    // 模糊搜索查询
    searchProject(e) {
      let vm = this
      //var searchProject = e.currentTarget.value
      vm.datalist = vm.projList.filter(function (item, index, arr) {
        return item.projName.indexOf(vm.searchProject1) != -1;
      })
    },
    // 关闭项目选择
    projectClose() {
      this.open = false
    },
    //返回
    goBack() {
      this.$router.push({ path: '/app/workRep/dayReport', query: { calDate: formatTime(this.form.reportTime, 'yyyy-MM-dd') } });
    },
    getWorkHourList() {
      var self = this;
      promise({
        url: BASIC + "/dic/item/list/cateCode",
        mounted: 'get',
        params: { cateCode: 'workHour' }
      }).then(res => {
        res.forEach(element => {
          element['key'] = element.dicCode;
          element['value'] = element.dicName;
        });
        self.workHourList = res;
      });
    },
    getWorkSubsidyAmt() {
      var self = this;
      promise({
        url: BASIC + "/dic/item/list/cateCode",
        mounted: 'get',
        params: { cateCode: 'workSubsidyAmt' }
      }).then(res => {
        self.workSubsidyAmt = res[0].dicCode;
      });
    },
    getProjList() {
      promise({
        url: PROJ_URL + "/getPersonProjectData",
        method: 'post',
        params: { personCode: this.userInfo.username }
      }).then(res => {
        res.list.forEach(element => {
          element['key'] = element.projCode;
          element['value'] = element.projName;
        });
        this.projList = res.list;

      });
    },
    addWorkDetail() {
      var proj = { id: guid(), mainId: this.form.id, status: '待审批', workHour: '', projCode: '', projName: '' };
      this.reportDetailList.push(proj);
    },
    removewWorkDetail(index, status) {
      if (status == '已通过') {
        return false;
      }
      this.reportDetailList.splice(index, 1);
    },
    commitDayReport() {
      //如果是
      if (this.type == 1) {
        this.form.deptId = this.userInfo.deptId;
        this.form.deptCode = this.userInfo.deptCode;
        this.form.deptName = this.userInfo.deptName;
        this.form.grade = this.userInfo.grade;
        this.form.settlePrice = this.userInfo.settlePrice;
        this.form.remoteSettlePrice = this.userInfo.remoteSettlePrice;
        this.form.userType = this.userInfo.userType;
      }
      var createTime = this.form.createTime;
      var signTime = this.form.signTime;

      delete this.form["createTime"];
      delete this.form["signTime"];
      this.form.reportTime = formatTime(new Date(this.form.reportTime), 'yyyy-MM-dd');
      var self = this;
      //更新实际的补助金额
      var workTotalHour = 0;
      var workTotalSubsidy = 0;
      if (this.reportDetailList.length == 0) {
        Toast({ message: '请填写项目工时信息!', duration: 1500, position: 'middle', className: "warning" });
        return false;
      }
      //0正常  1 项目为空   2 工时为空  3  工作内容为空 4 结算单价类型为空
      var flag = 0;
      var msg = "";
      this.reportDetailList.forEach(element => {
        var projCode = element.projCode;
        var workHour = element.workHour;
        var workDetail = element.workDetail;
        var workSubsidy = element.workSubsidy;
        if (isNullOrEmptyStr(projCode)) {
          flag = 1;
          msg = "请选择项目";
          return;
        }
        if (isNullOrEmptyStr(workHour)) {
          flag = 2;
          msg = "请选择工时";
          return;
        }
        if (isNullOrEmptyStr(workDetail)) {
          flag = 3;
          msg = "请填写工作内容";
          return;
        }
        // 外部人员才有这个验证
        if (self.userInfo.userType === 'outside' && !element.unitPriceType) {
          flag = 4;
          msg = "请选择结算单价类型";
          return;
        }
        if (workSubsidy == null) {
          workSubsidy = 0;
        }
        workTotalHour += parseInt(workHour);
        workTotalSubsidy += parseInt(workSubsidy);
      });
      if (flag != 0) {
        Toast({ message: msg, duration: 1500, position: 'middle', className: "warning" });
        return false;
      }
      if (workTotalHour > 16) {
        Toast({ message: "工作时长不能大于16小时!", duration: 1500, position: 'middle', className: "warning" });
        return false;
      }
      if (workTotalSubsidy > this.workSubsidyAmt) {
        Toast({ message: "工作补贴不能大于" + this.workSubsidyAmt + "元", duration: 1500, position: 'middle', className: "warning" });
        return false;
      }
      this.form.workTotalSubsidy = workTotalSubsidy;
      this.form.workTotalHour = workTotalHour;
      this.form.detailStr = JSON.stringify(this.reportDetailList);
      this.form.type = this.type;
      promise({
        url: BASIC + '/dayReport/save',
        method: "post",
        params: this.form
      }).then(res => {
        if (res.code == 0) {
          self.type == '2';
          this.form.createTime = createTime;
          this.form.signTime = signTime;
          Toast({ message: "操作成功!", duration: 1500, position: 'middle', className: "warning" });
          this.goBack();
        } else {
          Toast({ message: res.msg, duration: 1500, position: 'middle', className: "error" });
        }
      });
    },
    getUserInfo() {
      var self = this;
      promise({
        url: BASIC + '/dayReport/currInfo',
        method: 'get',
      }).then(res => {
        var resData = res.data;
        self.userInfo = resData;
        self.getTotalInfo();
        self.getProjList();
      });
    },
    getSignInfo() {
      var self = this;
      promise({
        url: BASIC + '/sign/signDate',
        method: 'get',
        params: { signDate: this.form.reportTime }
      }).then(res => {
        var resData = res.data;
        if (res.code == 0 && resData != null) {
          self.form.signTime = resData.createTime;
          self.form.signAddr = resData.signAddr;
          self.form.signId = resData.id;
          self.form.signCity = resData.signCity;
        }
        self.getUserInfo();
      });
    },
    getSignScope() {
      var self = this;
      promise({
        url: BASIC + '/sign/signPlace/enabled',
        method: 'get',
        params: {}
      }).then(res => {
        if (res.code == 0) {
          self.scopeList = res.data;
        }
      });
    },
    checkInScope() {//查看是否在范围内
      //获取所有的打卡范围
      var inSignScope = '否';
      var map = new BMap.Map("allmap");
      var pointA = new BMap.Point(this.form.reportLongitude, this.form.reportDimension);  // 创建点坐标A
      this.scopeList.forEach(element => {
        var pointB = new BMap.Point(element.longitude, element.dimension);
        var dist = map.getDistance(pointA, pointB).toFixed(2);
        var scope = parseFloat(element.scope);
        if (dist <= scope) {
          this.form.inSignScope = '是';
        }
      });
    },
    getCurrAddrInfo() {
      var self = this;
      //      var u = navigator.userAgent;
      // var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      // var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
      // if(isiOS){
      //      var geolocation = new BMap.Geolocation();
      //       geolocation.getCurrentPosition(function(r){
      //           if(this.getStatus() == BMAP_STATUS_SUCCESS){
      //               var address = r.address;
      //               var street_number=address.street_number;
      //               console.info(JSON.stringify(address));
      //               self.form.reportCity=address.city;
      //               self.form.reportCityCode=address.city_code;
      //               if(street_number!=null && street_number!='' && !isNaN(street_number)){
      //                 self.form.reportPlace=address.street +address.street_number + '号';
      //                 self.form.reportAddr=address.province + address.city + address.street + address.street_number + '号';
      //               }else{
      //                 self.form.reportPlace=address.street;
      //                 self.form.reportAddr=address.province + address.city + address.street;
      //               }
      //               self.form.reportLongitude=r.point.lng;
      //               self.form.reportDimension=r.point.lat;
      //               self.checkInScope();
      //           }
      //           else {
      //              Toast({  message:'failed'+this.getStatus(), duration: 1500,position: 'middle', className:"error" });
      //           }
      //       },{enableHighAccuracy: true});
      // }else if(isAndroid){
      //          var options={
      //            enableHighAccuracy:true,
      //            maximumAge:1000,
      //            timeout:5000
      //        }
      //        plus.geolocation.getCurrentPosition(function(p){
      //            console.log("浏览器定位"+JSON.stringify(p));
      //            var address = p.address;
      //            self.form.reportPlace=address.poiName;
      //            self.form.reportCity=address.city;
      //            self.form.reportCityCode=address.city_code;
      //           var streetNum= address.streetNum;
      //            if(streetNum!=null && streetNum!='' && !isNaN(streetNum)){
      //               self.form.reportAddr=address.province+address.city+address.district+address.street+address.streetNum+'号';
      //            }else{
      //               self.form.reportAddr=address.province+address.city+address.district+address.street+address.streetNum;
      //            }

      //            //获得当前位置的坐标
      //            var lng = p.coords.longitude //经度
      //            var lat = p.coords.latitude
      //            //把原始的坐标转换为百度坐标
      //            var ggPoint = new BMap.Point(lng,lat);
      //            var convertor = new BMap.Convertor();
      //            var pointArr = [];
      //            pointArr.push(ggPoint);
      //            convertor.translate(pointArr, 3, 5, function (data){
      //              if(data.status === 0) {
      //                  var point = new BMap.Point(data.points[0].lng, data.points[0].lat);
      //                  map.centerAndZoom(point, 17);
      //                  self.form.reportLongitude=data.points[0].lng;
      //                  self.form.reportDimension=data.points[0].lat;
      //                  var mk = new BMap.Marker(point);
      //                  map.addOverlay(mk);
      //                  map.panTo(point);
      //                  self.checkInScope();
      //              }
      //            })
      //          }, function(e){
      //      },options);
      // }
      //   var options={
      //       enableHighAccuracy:true,
      //       maximumAge:1000,
      //       timeout:5000
      //   }
      //   plus.geolocation.getCurrentPosition(function(p){
      //       console.log("浏览器定位"+JSON.stringify(p));
      //       var address = p.address;
      //       self.form.reportPlace=address.poiName;
      //       self.form.reportAddr=address.province+address.city+address.district+address.street+address.streetNum;
      //       //获得当前位置的坐标
      //       var lng = p.coords.longitude //经度
      //       var lat = p.coords.latitude
      //       //把原始的坐标转换为百度坐标
      //       var ggPoint = new BMap.Point(lng,lat);
      //       var convertor = new BMap.Convertor();
      //       var pointArr = [];
      //       pointArr.push(ggPoint);
      //       convertor.translate(pointArr, 3, 5, function (data){
      //         if(data.status === 0) {
      //             var point = new BMap.Point(data.points[0].lng, data.points[0].lat);
      //             map.centerAndZoom(point, 17);
      //             self.form.reportLongitude=data.points[0].lng;
      //             self.form.reportDimension=data.points[0].lat;
      //             var mk = new BMap.Marker(point);
      //             map.addOverlay(mk);
      //             map.panTo(point);
      //             self.checkInScope();
      //         }
      //       })
      //     }, function(e){
      // },options);


      //获取地图信息
      var geolocation = new BMap.Geolocation();
      geolocation.getCurrentPosition(function (r) {
        if (this.getStatus() == BMAP_STATUS_SUCCESS) {
          var address = r.address;
          var street_number = address.street_number;
          console.info(JSON.stringify(address));
          self.form.reportCity = address.city;
          self.form.reportCityCode = address.city_code;
          if (street_number != null && street_number != '' && !isNaN(street_number)) {
            self.form.reportPlace = address.street + address.street_number + '号';
            self.form.reportAddr = address.province + address.city + address.street + address.street_number + '号';
          } else {
            self.form.reportPlace = address.street;
            self.form.reportAddr = address.province + address.city + address.street;
          }
          self.form.reportLongitude = r.point.lng;
          self.form.reportDimension = r.point.lat;
          self.checkInScope();
        }
        else {
          Toast({ message: 'failed' + this.getStatus(), duration: 1500, position: 'middle', className: "error" });
        }
      }, { enableHighAccuracy: true });
    },
    //获取日报信息
    getDayReportInfo() {
      promise({
        url: BASIC + '/dayReport/id',
        method: "get",
        params: { id: this.form.id }
      }).then(res => {
        if (res.code == 0 && res.data != null && res.data.id != null) {
          this.form = res.data;
          if (this.type == '2') {
            this.getUserInfo();
          }
        }
      });
    },
    //获取日报详情
    getDayreportDetailInfo() {
      promise({
        url: BASIC + '/dayReport/detail/mainId',
        method: "get",
        params: { mainId: this.form.id }
      }).then(res => {
        if (res.code == 0 && res.data != null) {
          this.reportDetailList = res.data;

          this.reportDetailList.forEach(element => {
            element.workHour = element.workHour + "";
          });
          console.info(this.reportDetailList);
          if (this.reportDetailList.length == 0) {
            this.addWorkDetail();
          }
        }
      });
    },
    getTotalInfo() {
      var totalPrice = 0;
      var baseCity = this.userInfo.cityName;
      var signCity = this.form.signCity;
      var signId = this.form.signId;
      var totalHour = 0;
      var missionSubsidy = this.userInfo.missionSubsidy;
      var signTime = formatTime(this.form.signTime, 'hh:mm');
      var reportTime = formatTime(this.form.createTime, "hh:mm")
      var reportDate = formatTime(new Date(this.form.reportTime), 'yyyy-MM-dd');
      var createDate = formatTime(new Date(this.form.createTime), 'yyyy-MM-dd');
      var settleFlag = false;
      //判断打卡地点与base地是否一致(打卡且打卡地点与base地不一致)
      if (signCity != null && signCity != undefined && baseCity != null && baseCity != undefined && signCity != baseCity && signCity.indexOf(baseCity) == -1 && baseCity.indexOf(signCity) == -1) {
        settleFlag = true;
      }
      //判断上班打卡时间
      if (signId != null && signId != null && signTime >= '10:00') {

      } else {
        if (settleFlag) {
          totalPrice += missionSubsidy * 0.5;
        }
        totalHour += 4;
      }
      //判断日报时间 只有当天打卡 并且打卡时间在17:00 之后 下午才能算四个小时
      if (reportDate == createDate && reportTime > '17:00') {
        if (settleFlag) {
          totalPrice += missionSubsidy * 0.5;
        }
        totalHour += 4;
      }
      this.totalHour = totalHour;
      this.totalPirce = totalPrice;
      this.form.origTotalSubsidy = totalPrice;
      this.form.origTotalHour = totalHour;

    },
    hourSelectChange(data) {
      var missionSubsidy = this.userInfo.missionSubsidy;
      var workHour = data.workHour;
      var totalPirce = this.totalPirce;
      if (workHour <= 2) {
        data.workSubsidy = 0;
        data.origSubsidy = 0
      } else if (workHour > 2 && workHour < 6) {
        if (totalPirce > 0) {
          data.workSubsidy = missionSubsidy * 0.5;
          data.origSubsidy = missionSubsidy * 0.5;
        } else {
          data.workSubsidy = 0;
          data.origSubsidy = 0
        }
      } else if (workHour >= 6) {
        if (totalPirce > 0) {
          data.workSubsidy = missionSubsidy;
          data.origSubsidy = missionSubsidy;
        } else {
          data.workSubsidy = 0;
          data.origSubsidy = 0
        }
      }
    },
    hourProjChange(data) {
      var val = data.projCode;
      var proj = null;
      for (var i = 0; i < this.projList.length; i++) {
        var item = this.projList[i];
        if (item.projCode == val) {
          proj = item;
        }
      }
      if (proj != null && proj != undefined) {
        data.projId = proj.id;
        data.projName = proj.projName;
      }
    },
    compareDate(reportTime, createTime) {
      return formatTime(new Date(reportTime), 'yyyy-MM-dd') == formatTime(new Date(createTime), 'yyyy-MM-dd')
    },
    //获取费用信息
  },
  filters: {
    formatDate(date) {
      if (date == null || date == '') {
        return '';
      }
      return formatTime(new Date(date), 'yyyy年MM月dd日')
    },
    formattime(date) {
      if (date == null || date == '') {
        return '';
      }
      return formatTime(new Date(date), 'hh:mm')
    },
    reportTimeFilter(reportTime, createTime) {
      return formatTime(new Date(reportTime), 'yyyy-MM-dd') == formatTime(new Date(createTime), 'yyyy-MM-dd')
    }
  },
  created() {
    this.getWorkHourList();
    //获取日报补贴金额
    this.getWorkSubsidyAmt();
    this.getSignScope();
    if (this.type == 2) {
      this.getDayReportInfo();
      this.getDayreportDetailInfo();
    }
    if (this.type == 1) {
      this.form.createTime = new Date();
      this.getSignInfo();
      this.addWorkDetail();
    }
  },
  mounted() {
    $('.myContainer').css({ 'height': $('#app').height(), 'overflow': 'auto' })
    $('#app').css('height', $('#app').height() - 21)
    var currDate = new Date();

    if (this.type == 1) {
      this.form.createTime = currDate;
      this.getCurrAddrInfo();
    }
  }
}



// WEBPACK FOOTER //
// ./src/view/sign/dayReportAdd.vue